import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-roadmap',
  imports: [RouterModule],
  templateUrl: './roadmap.component.html',
  styleUrl: './roadmap.component.css',
})
export class RoadmapComponent {
  items = [
    { status: 'done', title: 'Dashboard itinérant', desc: 'Vue d\'ensemble pour les marchands itinérants avec météo et événements.' },
    { status: 'done', title: 'Prévisions météo', desc: 'Intégration météo dans les recommandations de quantités.' },
    { status: 'wip', title: 'Application mobile', desc: 'Version mobile native iOS et Android.' },
    { status: 'wip', title: 'Import CSV', desc: 'Importez vos données de vente depuis Excel ou CSV.' },
    { status: 'planned', title: 'Multi-utilisateurs', desc: 'Gestion d\'équipe avec rôles et permissions.' },
    { status: 'planned', title: 'Intégrations caisse', desc: 'Connexion avec les caisses enregistreuses populaires.' },
  ];
}